import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import logoImg from "@/assets/logo.png";
const Footer = () => {
  return <footer className="bg-safari-brown text-safari-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo and Description */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src={logoImg} alt="Kijani Arusha Airport Lodge" className="h-12 w-auto object-contain" />
              <h3 className="font-heading text-xl font-bold">Arusha Airport Lodge</h3>
            </div>
            <p className="text-safari-tan mb-4 max-w-md">
              Experience luxury safari accommodation in the heart of Arusha, Tanzania. 
              Just 7 minutes from the airport, our eco-friendly lodge offers 9 beautifully 
              appointed en-suite rooms perfect for your African safari adventure.
            </p>
            
            {/* Social Media Links */}
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-safari-tan hover:text-safari-cream transition-colors"
                aria-label="Visit our Facebook page"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-safari-tan hover:text-safari-cream transition-colors"
                aria-label="Visit our Instagram profile"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-safari-tan hover:text-safari-cream transition-colors"
                aria-label="Visit our Twitter profile"
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/rooms" className="text-safari-tan hover:text-safari-cream transition-colors">Rooms</Link>
              </li>
              <li>
                <Link to="/dining" className="text-safari-tan hover:text-safari-cream transition-colors">
                  Dining
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-safari-tan hover:text-safari-cream transition-colors">
                  Book Your Stay
                </Link>
              </li>
            </ul>
          </div>

          {/* Booking Platforms */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Book With Us</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.booking.com/hotel/tz/kijani-arusha-airport-lodge.html?auth_success=1&account_created=1" target="_blank" rel="noopener noreferrer" className="text-safari-tan hover:text-safari-cream transition-colors">
                  Booking.com
                </a>
              </li>
              <li>
                <a href="https://agoda.com/vi-vn/kijani-arusha-airport-lodge/hotel/arusha-tz.html?cid=1844104" target="_blank" rel="noopener noreferrer" className="text-safari-tan hover:text-safari-cream transition-colors">
                  Agoda
                </a>
              </li>
              <li>
                <a href="https://tripadvisor.com" target="_blank" rel="noopener noreferrer" className="text-safari-tan hover:text-safari-cream transition-colors">
                  TripAdvisor
                </a>
              </li>
              <li>
                <a href="https://hotels.com" target="_blank" rel="noopener noreferrer" className="text-safari-tan hover:text-safari-cream transition-colors">
                  Hotels.com
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-safari-green-light flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-safari-tan text-sm">
                      Olasiti b, Burka<br />
                      Arusha, Tanzania
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-safari-green-light flex-shrink-0" />
                  <div className="flex flex-col">
                    <a href="tel:+255790222305" className="text-safari-tan text-sm hover:text-safari-cream transition-colors">
                      +255 790 222 305
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <MessageCircle className="h-5 w-5 text-safari-green-light flex-shrink-0" />
                  <div className="flex flex-col">
                    <a href="https://wa.me/255653491827" target="_blank" rel="noopener noreferrer" className="text-safari-tan text-sm hover:text-safari-cream transition-colors">
                      WhatsApp: +255 653 491 827
                    </a>
                  </div>
                </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-safari-green-light flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="mailto:hello@kijaniarushaairportlodge.com" className="text-safari-tan text-sm hover:text-safari-cream transition-colors">
                    hello@kijaniarushaairportlodge.com
                  </a>
                  <a href="mailto:reservations@kijaniarushaairportlodge.com" className="text-safari-tan text-sm hover:text-safari-cream transition-colors">
                    reservations@kijaniarushaairportlodge.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Partners & Login */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Partners</h4>
            <ul className="space-y-2 mb-4">
              <li>
                <Link to="/partners" className="text-safari-tan hover:text-safari-cream transition-colors">
                  Partners
                </Link>
              </li>
              <li>
                
              </li>
              <li>
                
              </li>
            </ul>
            
          </div>
        </div>

        <div className="border-t border-safari-brown-light mt-8 pt-8 text-center">
          <p className="text-safari-tan text-sm">
            © 2024 Kijani Arusha Airport Lodge. All rights reserved. | 
            <span className="ml-1">Experience the beauty of Tanzania</span>
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;